module.exports = __webpack_public_path__ + "media/images/icon-checkbox-check-8eaef3f98376d24acadbe95433d3aca2.svg";